module.exports = __webpack_public_path__ + "static/media/halloweenmini.6d3d35fa.jpg";